import React from 'react';
import {
  WORDMARK_GLYPHS,
  WORDMARK_HEART_PATH,
  WORDMARK_VIEW_BOX,
  WORDMARK_VIEW_BOX_SIZE,
} from './wordmarkData';

export interface WordmarkProps {
  /** Rendered height in px. */
  height?: number;
  className?: string;
  /** Accessible name; leave undefined (with `decorative`) when the name is visible next to it. */
  label?: string;
  decorative?: boolean;
}

/**
 * The stacked "Ghara / miat" lettering and the small heart of the logo as
 * inline SVG, filled with `currentColor` so a caller can tint it. The brand
 * rule is lipstick red: use `Logo variant="wordmark"` unless you need another
 * colour (for example cream on the lipstick icon tile).
 */
export const Wordmark: React.FC<WordmarkProps> = ({
  height = 40,
  className,
  label,
  decorative = false,
}) => {
  const width = Math.round(
    (height * WORDMARK_VIEW_BOX_SIZE.width) / WORDMARK_VIEW_BOX_SIZE.height
  );
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={WORDMARK_VIEW_BOX}
      width={width}
      height={height}
      className={['block', className].filter(Boolean).join(' ')}
      focusable="false"
      data-logo="wordmark"
      {...(decorative || !label
        ? { 'aria-hidden': true }
        : { role: 'img', 'aria-label': label })}
    >
      {WORDMARK_GLYPHS.map(glyph => (
        <g key={glyph.transform} transform={glyph.transform}>
          <path
            d={glyph.d}
            fill="currentColor"
            stroke="currentColor"
            strokeWidth={14}
            strokeLinejoin="round"
            strokeLinecap="round"
          />
        </g>
      ))}
      <path d={WORDMARK_HEART_PATH} fill="currentColor" />
    </svg>
  );
};

export default Wordmark;
